import { render, staticRenderFns } from "./trainingAgenda.vue?vue&type=template&id=4c22c1d0&scoped=true&"
import script from "./trainingAgenda.vue?vue&type=script&lang=js&"
export * from "./trainingAgenda.vue?vue&type=script&lang=js&"
import style0 from "./trainingAgenda.vue?vue&type=style&index=0&id=4c22c1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c22c1d0",
  null
  
)

export default component.exports